// TradeLeaders.tsx
import { Chat, Heading, Text } from '@components'
import { api } from '@here/api'
import { useQuery } from '@tanstack/solid-query'
import { Show } from 'solid-js'
import { Grid } from 'styled-system/jsx'

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000

async function fetchTradeLeadersChannelId(): Promise<string | undefined> {
	const sb = api()
	const { data, error } = await sb
		.from('channel')
		.select('id')
		.eq('name', 'trade-leaders')
		.limit(1)

	if (error) throw error
	return data?.[0]?.id
}

export default function TradeLeaders(props: { minimalist?: boolean }) {
	const q = useQuery(() => ({
		queryKey: ['channel-id', 'trade-leaders'],
		queryFn: fetchTradeLeadersChannelId,
		staleTime: ONE_WEEK_MS, // cache freshness: 1 week
		gcTime: ONE_WEEK_MS,    // cache retention: 1 week
		retry: 1,
		placeholderData: undefined,
	}))

  const minimalist = props.minimalist ?? false

	return (
		<Grid>
			<Show when={!q.isLoading} fallback={<Text>Loading…</Text>}>
				<Show
					when={q.data}
					fallback={<Text color="fg.muted">Channel “trade-leaders” not found.</Text>}
				>
					{(channelId) => (
						<Chat
							height="calc(var(--vh) * 100 - 122px)"
							currentChannelId={channelId()}
							setIsReadOnly={true}
              isMinimal
						/>
					)}
				</Show>
			</Show>
		</Grid>
	)
}
